const OFFICIAL_TREECHAT_DOMAINS = ['treechat.com', 'treechat.ai', 'treechat.io'] as const
const TREECHAT_BRAND = 'treechat'
const URL_PARSE_BASE = 'https://treechat.com'

const LEETSPEAK_SUBSTITUTIONS: Record<string, string> = {
    '0': 'o',
    '1': 'i',
    '2': 'z',
    '3': 'e',
    '4': 'a',
    '5': 's',
    '6': 'g',
    '7': 't',
    '8': 'b',
    '9': 'g',
}

function normalizeHostname(hostname: string): string {
    return hostname.trim().toLowerCase().replace(/\.$/, '')
}

function isDomainOrSubdomain(hostname: string, domain: string): boolean {
    return hostname === domain || hostname.endsWith(`.${domain}`)
}

function normalizeBrandLabel(label: string): string {
    return label
        .toLowerCase()
        .replace(/[0-9]/g, character => LEETSPEAK_SUBSTITUTIONS[character] || character)
        .replace(/[^a-z]/g, '')
}

export function isOfficialTreechatHostname(hostname: string): boolean {
    const normalizedHostname = normalizeHostname(hostname)
    return OFFICIAL_TREECHAT_DOMAINS.some(domain => isDomainOrSubdomain(normalizedHostname, domain))
}

export function isBlockedExternalNavigation(url: string | null | undefined): boolean {
    if (typeof url !== 'string' || !url.trim()) return false

    try {
        const parsedUrl = new URL(url, URL_PARSE_BASE)
        const hostname = normalizeHostname(parsedUrl.hostname)
        if (!hostname || isOfficialTreechatHostname(hostname)) return false

        const hostnameUsesTreechatBrand = normalizeBrandLabel(hostname).includes(TREECHAT_BRAND)
        const userInfoUsesTreechatBrand = normalizeBrandLabel(
            `${parsedUrl.username}${parsedUrl.password}`,
        ).includes(TREECHAT_BRAND)

        return hostnameUsesTreechatBrand || userInfoUsesTreechatBrand
    } catch {
        return false
    }
}
